import React from 'react';
import { colors } from '../../designSystem/colors/color';
import { Tabber2, TabItem2 } from '../../designSystem/Tabber2';

export function TabTopPanel(props:{
    items:TabItem2[],
    selectedTabName:string,
    onClick:(tabName:string)=>void
}):JSX.Element
{
    return (
        <div style={{borderBottom:`1px solid ${colors.divider.light}`, borderRadius: '4px', backgroundColor:'white'}}>
            <Tabber2
                variant="text"
                alignment='center'
                items={props.items}
                selectedTabName={props.selectedTabName}
                onClick={props.onClick} />
        </div>
    );
}